import { MRT_ColumnDef } from 'material-react-table';
import { CopyComponent } from '../../../components/CopyComponent';
import { Link } from 'react-router-dom';
import { getFormattedDate, numberFormatter } from '../../../utils/utilities';
import React from 'react';
import { ColumnSizing } from '../tables-context';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';

import '../../../components/table/MaterialReactTable.scss';
import { TableCell } from '../../../components/table/TableCell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { DateComponent } from '../../../components/DateComponent';

export enum DisputeTableAccessorKey {
    transactionId = 'transactionId',
    orderId = 'orderId',
	authorizationID = 'authorizationID',
    mid = 'mid',
    disputeType = 'disputeType',
    requestDate = 'requestDate',
    transactionDate = 'transactionDate',
    isRefunded = 'isRefunded',
    descriptor = 'descriptor',
    currency = 'currency',
    amount = 'amount',
    cardBrand = 'cardBrand',
    bin = 'bin',
    providerName = 'providerName',
    type = 'stage',
    arn = 'arn',
    isWebhook = 'isWebhook',
    createdOn = 'createdOn',
		isFileImported = 'isFileImported',
    isManualInserted = 'isManualInserted',
}

export const defaultDisputesColumnSizing: ColumnSizing = {
	[DisputeTableAccessorKey.transactionId]: 120,
	[DisputeTableAccessorKey.orderId]: 120,
	// [DisputeTableAccessorKey.authorizationID]: 100,
	[DisputeTableAccessorKey.mid]: 150,
	[DisputeTableAccessorKey.disputeType]: 100,
	[DisputeTableAccessorKey.type]: 100,
	[DisputeTableAccessorKey.providerName]: 120,
	[DisputeTableAccessorKey.requestDate]: 100,
	[DisputeTableAccessorKey.transactionDate]: 100,
	[DisputeTableAccessorKey.isRefunded]: 100,
	[DisputeTableAccessorKey.descriptor]: 120,
	[DisputeTableAccessorKey.currency]: 50,
	[DisputeTableAccessorKey.amount]: 100,
	[DisputeTableAccessorKey.cardBrand]: 90,
	[DisputeTableAccessorKey.arn]: 90,
	[DisputeTableAccessorKey.isWebhook]: 90,
	[DisputeTableAccessorKey.isFileImported]: 90,
	[DisputeTableAccessorKey.isManualInserted]: 90,
	[DisputeTableAccessorKey.bin]: 90,
	[DisputeTableAccessorKey.createdOn]: 100,
};

export const defaultDisputesPanelColumnSizing: ColumnSizing = {
    [DisputeTableAccessorKey.createdOn]: 150,
    [DisputeTableAccessorKey.disputeType]: 220,
    [DisputeTableAccessorKey.type]: 120,
    [DisputeTableAccessorKey.providerName]: 120,
    [DisputeTableAccessorKey.cardBrand]: 150,
    [DisputeTableAccessorKey.isWebhook]: 150,
    [DisputeTableAccessorKey.bin]: 150,
    // [DisputeTableAccessorKey.mid]: 150,
    // [DisputeTableAccessorKey.transactionId]: 120,
    // [DisputeTableAccessorKey.orderId]: 120,
    // [DisputeTableAccessorKey.requestDate]: 100,
    // [DisputeTableAccessorKey.transactionDate]: 100,
    // [DisputeTableAccessorKey.isRefunded]: 100,
    // [DisputeTableAccessorKey.descriptor]: 120,
    // [DisputeTableAccessorKey.currency]: 50,
    // [DisputeTableAccessorKey.amount]: 100,
    // [DisputeTableAccessorKey.arn]: 90,
};

export interface IPotentialMatch {
	value: number;
	matchedFields: string[];
	transactionId: string;
}

export interface IDisputeItem {
	arn: string;
	id: string;
	mid: string;
	orderId: string;
	transactionId: string;
	partnerId: string;
	descriptor : string;
	amount: number;
	currency: string;
	disputeType: string;
	cardBrand: string;
	bin: string;
	last4: string;
	message: string;
	createdOn: string;
	requestDate: string;
	transactionDate: string;
	isRefunded: boolean;
	isWebhook?: boolean;
	providerName: string;
	stage: string;
	matchError: string;
	isPined: boolean;
	potentialMatches: IPotentialMatch[];
}

export const getTableDate = (value, isTime?: boolean): JSX.Element => (
	<>
		<div className="fs-8">
			{getFormattedDate(value, 'dd MMM, yyyy')}
	  </div>
		{isTime && (
			<div className="fs-9">
		    {getFormattedDate(value, 'hh:mm a')}
			</div>
		)}
	</>
);

export const getBinLast4 = (bin, last4): JSX.Element => (
	<>
		{
			bin && last4 && (
				<>
					<div className="fs-8">{bin}</div>
					<div className="fs-8">{last4}</div>
				</>
			)
		}
		{bin && !last4 && <div className="fs-8">{bin}</div>}
		{!bin && last4 && <div className="fs-8">{last4}</div>}
		{!bin && !last4 && <div>-</div>}
	</>
);

export const getAmount = (amount, currency): JSX.Element => (
	<>
		<div className="text-dark fw-bolder d-block fs-8">
			{currency === 'USD' ? '$' : ''}{numberFormatter(amount)}
		</div>
		<div className="text-muted d-block fs-9">
			{currency}
		</div>
	</>
);

export const defaultDisputesColumns: MRT_ColumnDef<IDisputeItem>[] = [
	// {
	//     accessorKey: DisputeTableAccessorKey.transactionId,
	//     header: 'Transaction Id',
	//     enableSorting: false,
	//     Header: <span className="text-muted fw-bolder main-font-family">Transaction Id</span>,
	//     Cell: ({ renderedCellValue, row }: any): JSX.Element => {
	//         return (
	//             <div className="margin-left-0 d-flex align-items-center main-font-family text-black fs-6 ms-3 fc-text-overflow">
	//                 <CopyComponent additionalClass="fc-copy-icon" value={renderedCellValue} title="Transaction Id" />
	//                 <div className="fc-text-overflow">
	//                     {renderedCellValue}
	//                 </div>
	//             </div>
	//         );
	//     },
	// },
	{
		accessorKey: DisputeTableAccessorKey.createdOn,
		header: 'Created on',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Created on</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const year = new Date(renderedCellValue).getFullYear();
			return (
				year === 1
					? <div className="fw-bolder">-</div>
					: (
						<TableCell
							additionalClass="main-font-family text-black"
							density={table?.options?.state?.density} isTextOverflow={false}
						>
							<DateComponent
								value={renderedCellValue}
								placement="top"
								isTooltip
								isTime
							/>
						</ TableCell>
					)
			);
		}
	},
	{
		accessorKey: DisputeTableAccessorKey.transactionDate,
		header: 'Authorization date',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Authorization date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const year = new Date(renderedCellValue).getFullYear();
			return (
				year === 1
					? <div className="fw-bolder">-</div>
					: (
						<TableCell
							additionalClass="main-font-family text-black"
							density={table?.options?.state?.density} isTextOverflow={false}
						>
							<DateComponent
								value={renderedCellValue}
								placement="top"
								isTooltip
								isTime
							/>
						</ TableCell>
					)
			);
		}
	},
	{
		accessorKey: DisputeTableAccessorKey.requestDate,
		header: 'Request date',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Request date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const year = new Date(renderedCellValue).getFullYear();
			return (
				year === 1
					? <div className="fw-bolder">-</div>
					: (
						<TableCell
							additionalClass="main-font-family text-black"
							density={table?.options?.state?.density} isTextOverflow={false}
						>
							<DateComponent
								value={renderedCellValue}
								placement="top"
								isTooltip
								isTime
							/>
						</ TableCell>
					)
			);
		}
	},
	{
		accessorKey: DisputeTableAccessorKey.orderId,
		header: 'Order id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Order id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const path = `/orders/${renderedCellValue}`;
			return (
				<TableCell
					additionalClass="margin-left-0 d-flex align-items-center main-font-family text-black fs-7"
					density={table?.options?.state?.density}
					isTextOverflow={true}
				>
					<CopyComponent additionalClass="fc-copy-icon" value={renderedCellValue} title="Order Id" />
					<Link
						to={path}
						className="text-black fc-text-overflow"
						target="_blank"
					>
						<div className="fc-text-overflow">
							{renderedCellValue}
						</div>
					</Link>
				</ TableCell>
			);
		},
	},

	{
		accessorKey: DisputeTableAccessorKey.mid,
		header: 'Merchant name',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family ">Merchant name</span>,
		Cell: ({ row, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7 fc-text-overflow"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<RelatedEntityNameLink id={row?.original?.mid} type={RELATED_ENTITY_TYPE.MERCHANT}/>
			</ TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.disputeType,
		header: 'Dispute type',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Dispute type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fc-text-overflow">
					{renderedCellValue || '-'}
				</div>
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.type,
		header: 'Stage',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Stage</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fc-text-overflow">
					{renderedCellValue || '-'}
				</div>
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.providerName,
		header: 'Source',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Source</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fc-text-overflow">
					{renderedCellValue || '-'}
				</div>
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.descriptor,
		header: 'Descriptor',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Descriptor</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7 fc-text-overflow"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue || '-'}
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.amount,
		header: 'Amount',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Amount</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex flex-column align-items-start main-font-family"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getAmount(renderedCellValue, row.original.currency)}
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.cardBrand,
		header: 'Card brand',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Card brand</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fc-text-overflow">
					{renderedCellValue || '-'}
				</div>
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.bin,
		header: 'Bin / Last 4',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Bin / Last 4</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getBinLast4(renderedCellValue, row?.original?.last4)}
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.arn,
		header: 'ARN',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">ARN</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7 d-flex align-items-center"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue && <CopyComponent additionalClass="fc-copy-icon" value={renderedCellValue} title="ARN" />}
				<div className="fc-text-overflow">
					{renderedCellValue || '-'}
				</div>
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.isWebhook,
		header: 'Is webhook',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Is webhook</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue && <FontAwesomeIcon icon={faCircleCheck} width={16} className="text-danger h-20px"/>}
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.isFileImported,
		header: 'Is file imported',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Is file imported</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue && <FontAwesomeIcon icon={faCircleCheck} width={16} className="text-danger h-20px"/>}
			</TableCell>
		),
	},
	{
		accessorKey: DisputeTableAccessorKey.isManualInserted,
		header: 'Is manual inserted',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Is manual inserted</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue && <FontAwesomeIcon icon={faCircleCheck} width={16} className="text-danger h-20px"/>}
			</TableCell>
		),
	},

	// {
	//     accessorKey: DisputeTableAccessorKey.last4',
	//     header: 'Last 4 numbers',
	//     enableSorting: false,
	//     Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Last 4 numbers</span>,
	//     Cell: ({ renderedCellValue, row }: any): JSX.Element => (
	//         <div className="main-font-family fs-6 ">{renderedCellValue}</div>
	//     ),
	//     size: 90,
	// }
];

// request date, transaction date (authorization date), irefunded (refund transaction id)

export const defaultDisputesPanelColumns: MRT_ColumnDef<IDisputeItem>[] = [
    {
        accessorKey: DisputeTableAccessorKey.createdOn,
        header: 'Created on',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Created on</span>,
        Cell: ({ renderedCellValue, table }: any): JSX.Element => (
          <TableCell
            additionalClass="main-font-family text-black"
            density={table?.options?.state?.density}
            isTextOverflow={false}
          >
              {/*<div className="fs-7">*/}
              {/*    {getFormattedDate(renderedCellValue, 'dd MMM, yyyy')}*/}
              {/*</div>*/}
              {/*<div className="fs-8">*/}
              {/*    {getFormattedDate(renderedCellValue, 'hh:mm a')}*/}
              {/*</div>*/}
	          <DateComponent
		          value={renderedCellValue}
		          placement="top"
		          isTooltip
		          isTime
	          />
          </TableCell>
        ),
    },
    {
        accessorKey: DisputeTableAccessorKey.disputeType,
        header: 'Dispute type',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Dispute type</span>,
        Cell: ({ renderedCellValue, table }: any): JSX.Element => (
            <TableCell
                additionalClass="d-flex align-items-center main-font-family text-black fs-7"
                density={table?.options?.state?.density}
                isTextOverflow={false}
            >
                <div className="fc-text-overflow">
                    {renderedCellValue}
                </div>
            </TableCell>
        ),
    },
    {
        accessorKey: DisputeTableAccessorKey.type,
        header: 'Type',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Type</span>,
        Cell: ({ renderedCellValue, table }: any): JSX.Element => (
            <TableCell
                additionalClass="d-flex align-items-center main-font-family text-black fs-7"
                density={table?.options?.state?.density}
                isTextOverflow={false}
            >
                <div className="fc-text-overflow">
                    {renderedCellValue}
                </div>
            </TableCell>
        ),
    },
    {
        accessorKey: DisputeTableAccessorKey.providerName,
        header: 'Source',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Source</span>,
        Cell: ({ renderedCellValue, table }: any): JSX.Element => (
            <TableCell
                additionalClass="d-flex align-items-center main-font-family text-black fs-7"
                density={table?.options?.state?.density}
                isTextOverflow={false}
            >
                <div className="fc-text-overflow">
                    {renderedCellValue ? renderedCellValue : '-'}
                </div>
            </TableCell>
        ),
    },
    {
        accessorKey: DisputeTableAccessorKey.cardBrand,
        header: 'Card brand',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Card brand</span>,
        Cell: ({ renderedCellValue, table }: any): JSX.Element => (
            <TableCell
                additionalClass="main-font-family fs-7"
                density={table?.options?.state?.density}
                isTextOverflow={false}
            >
                <div className="fc-text-overflow">
                    {renderedCellValue}
                </div>
            </TableCell>
        ),
    },
    {
        accessorKey: DisputeTableAccessorKey.bin,
        header: 'Bin / Last 4',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Bin / Last 4</span>,
        Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (
            <TableCell
                additionalClass="main-font-family fs-7"
                density={table?.options?.state?.density}
                isTextOverflow={false}
            >
	            {getBinLast4(renderedCellValue, row?.original?.last4)}
            </TableCell>
        ),
    },
    {
        accessorKey: DisputeTableAccessorKey.isWebhook,
        header: 'Is webhook',
        enableSorting: false,
        Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Is webhook</span>,
        Cell: ({ renderedCellValue, table }: any): JSX.Element => (
            <TableCell
                additionalClass="main-font-family fs-7 w-100px"
                density={table?.options?.state?.density}
                isTextOverflow={false}
            >
                {renderedCellValue && <FontAwesomeIcon icon={faCircleCheck} width={16} className="text-danger h-20px"/>}
            </TableCell>
        ),
    },
	{
		accessorKey: DisputeTableAccessorKey.isFileImported,
		header: 'Is file imported',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Is file imported</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue && <FontAwesomeIcon icon={faCircleCheck} width={16} className="text-danger h-20px"/>}
			</TableCell>
		),
	},
];
